import React from "react";
import PropTypes from "prop-types";
import Table from "@mui/material/Table";
import TableHead from "@mui/material/TableHead";
import TableBody from "@mui/material/TableBody";
import TableRow from "@mui/material/TableRow";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import MCard from "components/Shared/MCard.tsx";
import { dateTimeToStringWithDOW } from "components/Shared/Formatters";

class CaseReturns extends React.Component {
    render() {
        const { caseReturns, className } = this.props;

        if (caseReturns.length === 0) {
            return null;
        }

        const rows = caseReturns.map(({ id, author, body, created }) => (
            <TableRow key={id}>
                <TableCell>
                    <div>{author}</div>
                    <div className="indent">{body}</div>
                </TableCell>
                <TableCell>{dateTimeToStringWithDOW(created)}</TableCell>
            </TableRow>
        ));

        return (
            <MCard
                title="Case Returns"
                className={className}
                fields={[{
                    key: "case-returns-card",
                    control:
                        <TableContainer>
                            <Table>
                                <TableHead>
                                    <TableRow>
                                        <TableCell>Author</TableCell>
                                        <TableCell>Returned</TableCell>
                                    </TableRow>
                                </TableHead>
                                <TableBody>{rows}</TableBody>
                            </Table>
                        </TableContainer>
                }]}
            />
        );
    }
}

CaseReturns.defaultProps = {
    caseReturns: [],
};

CaseReturns.propTypes = {
    caseReturns: PropTypes.array,
    className: PropTypes.string,
};

export default CaseReturns;